/**
 * BuiltBy — replaces the design's Investors strip with QuantumX
 * positioning. Same visual treatment (200px stat / copy two-up).
 */
export default function BuiltBy() {
  return (
    <section className="investors">
      <div className="container">
        <div className="invest-grid">
          <div className="stat">14<sup>products</sup></div>
          <div className="copy">
            QXAI is part of the QuantumX ecosystem — a federated family of AI products
            built by Media Minds AI Group. From TrustGraph (AI-search visibility) to
            V-Verify (forensic verification) to AI CEO (autonomous business operator),
            every QuantumX product shares one principle: privacy and ownership belong to
            the user, not the platform.
            <small>· Status: live · Stage: public access</small>
          </div>
        </div>
      </div>
    </section>
  );
}
